import { alpha, styled } from "@mui/material";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

const ROW_SELECTED_OPACITY = 0.12;

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
	backgroundColor: theme.palette.background.paper,
	[`& .${gridClasses.virtualScroller}`]: {
		backgroundColor: theme.palette.background.paper,
	},
	[`& .${gridClasses.row}`]: {
		transition: "background-color 120ms ease, box-shadow 120ms ease",
		"&:hover": {
			backgroundColor:
				theme.palette.mode === "dark"
					? alpha(theme.palette.common.white, 0.04)
					: alpha(theme.palette.common.black, 0.025),
			"@media (hover: none)": {
				backgroundColor: "transparent",
			},
		},
		"&.Mui-selected": {
			backgroundColor: alpha(theme.palette.primary.main, ROW_SELECTED_OPACITY),
			"&:hover": {
				backgroundColor: alpha(
					theme.palette.primary.main,
					ROW_SELECTED_OPACITY + theme.palette.action.hoverOpacity,
				),
				"@media (hover: none)": {
					backgroundColor: alpha(
						theme.palette.primary.main,
						ROW_SELECTED_OPACITY,
					),
				},
			},
		},
	},
	[`& .${gridClasses.cell}`]: {
		backgroundClip: "padding-box",
	},
}));
